// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f3a922c9","455":"375d5989","977":"26f4a581"}[chunkId] + ".chunk.js";
};